import {
	GET_RECENTLY_VIEWED_REQUEST,
	GET_RECENTLY_VIEWED_SUCCESS,
	GET_RECENTLY_VIEWED_ERROR
} from 'actions/recentlyViewedActions';
import { LOADING, SUCCESS, ERROR, INIT } from 'utils/asyncStatusHelper';
import { logout } from 'actions/LoginSignupActions/logoutActions';
import { login } from 'actions/LoginSignupActions/loginActions';
import { removeObject } from 'utils/localStorage';

const INITIAL_STATE = {
	asyncStatus: INIT
};
export default function recentlyViewedSummary(state = INITIAL_STATE, action = null) {
	switch (action.type) {
		case GET_RECENTLY_VIEWED_REQUEST:
			return { ...state, asyncStatus: LOADING };

		case GET_RECENTLY_VIEWED_SUCCESS:
			return {
				list: action.data,
				asyncStatus: SUCCESS
			};

		case GET_RECENTLY_VIEWED_ERROR:
			return {
				asyncStatus: ERROR
			};
		case login.USER_LOGIN_SUCCESS:
		case logout.LOGOUT_SUCCESS:
			clearRecentlyViewedData();
			return state;
		default:
			return state;
	}
}

function clearRecentlyViewedData() {
	removeObject('browsed-products');
}
